<template>
  <div class="foreign-passport">
    <div class="foreign-passport__row serial">
      <input-text
        type="text"
        placeholder="Серия и номер"
        title="Серия и номер"
        v-bind:violations="numberInputError"
        v-mask="''"
        v-model="identification.number" />
      <input-date
        class="foreign-passport__date"
        label="Когда выдан"
        v-bind:violations="whenIssuedInputError"
        v-model="identification.whenIssued" />
    </div>
    <textarea-length-limitation
      class="foreign-passport__belay"
      v-model="identification.whoIssued"
      placeholder="Кем выдан"
      title="Кем выдан"
      rows="3"
      v-bind:violations="whoIssuedInputError"
      v-bind:max-length="200" />
  </div>
</template>

<script>
import { Identification } from '@/storage/gateways/PatientGateway';
import InputText from '@/components/InputText.vue';
import TextareaLengthLimitation from '@/components/TextareaLengthLimitation.vue';
import InputDate from '@/components/InputDate.vue';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

/**
 * События обновления модели
 * @type {string}
 */
const ON_MODEL_UPDATE = 'on-model-update';

export default {
  components: {
    InputDate,
    InputText,
    TextareaLengthLimitation,
  },
  computed: {
    numberInputError: resolveInputErrors('identification.number'),
    whenIssuedInputError: resolveInputErrors('identification.when_issued'),
    whoIssuedInputError: resolveInputErrors('identification.who_issued'),
  },
  name: 'FormForeignPassport',
  props: {
    initIdentification: { required: true, type: Identification },
    inputErrors: { required: true, type: Object },
  },
  watch: {
    /**
     * @description Данные обновились
     *
     * @param newValue
     */
    identification: {
      handler(newValue) {
        this.$emit(ON_MODEL_UPDATE, newValue);
      },
      deep: true,
    },
    /**
     * @description Данные родителя обновились
     *
     * @param newValue
     */
    initIdentification: {
      handler(newValue) {
        this.identification = newValue;
      },
      deep: true,
    },
  },
  created() {
    this.identification = this.initIdentification;
    this.identification.serial = '';
  },
  data() {
    return {
      /**
       * @description Удостоверение личности
       * @type {object}
       */
      identification: {},
    };
  },
};
</script>

<style scoped lang="scss">
.foreign-passport {
  display: grid;
  row-gap: 20px;
  &__row {
    display: grid;
    grid-template-columns: 333px 236px;
    grid-gap: 11px;
    &.serial {
      grid-template-columns: 1fr 1fr;
      max-width: 100%;
    }
  }
  &__copy {
    margin-top: 15px;
    &__button {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      margin: 0 0 2px 0;
      color: var(--unfocus-color);
      &:after {
        content: '';
        background-image: url("@/assets/img/copy-blue.svg");
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: contain;
        margin: 0 0 0 10px;
        width: 15px;
        height: 15px;
      }
    }
  }
  &__invalid {
    color: var(--warning-color);
    font-size: 12px;
    font-weight: 400;
    padding: 0.125rem;
    margin-bottom: 0;
  }
  &__snils {
    width: 333px;
  }
  &__belay {
    width: 100%;
  }
}
@media screen and (max-width: 970px) {
  .foreign-passport {
    &__belay,
    &__snils,
    &__date {
      width: 100%;
    }
    &__row {
      grid-template-columns: 1fr;
      gap: 20px;
      &.serial {
        grid-template-columns: 1fr;
      }
    }
    &__representative {
      &__row {
        grid-template-columns: 1fr;
      }
    }
  }
}
@media screen and (max-width: 480px) {
  .foreign-passport {
    &__medical {
      &-card {
        padding: 20px 15px;
        &__info {
          flex-direction: column;
          align-items: flex-start;
        }
        &__buttons {
          width: 230px;
          flex-direction: column;
        }
        &__button {
          &-print {
            display: none;
          }
          &-save {
            max-width: 100%;
          }
        }
      }
    }
    &__representative {
      &__row {
        &.document {
          grid-template-columns: 1fr;
        }
      }
    }
  }
}
</style>
